module.exports = __webpack_public_path__ + "img/b37834a.png";